import { useState } from 'react'
import { useAuth } from '../lib/useAuth'

export function Login() {
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')
  const { sendMagicLink } = useAuth()

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError('')
    try {
      await sendMagicLink(email)
      setSent(true)
    } catch (err) {
      setError('Failed to send magic link. Try again.')
    }
  }

  if (sent) {
    return (
      <div className="login-page">
        <div className="login-card">
          <div className="logo">🏨</div>
          <h1>DIGSAFE Admin</h1>
          <p className="subtitle">Check your email</p>
          <p>We sent a login link to <strong>{email}</strong></p>
          <button className="btn-secondary" onClick={() => setSent(false)}>
            Use a different email
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="logo">🏨</div>
        <h1>DIGSAFE Admin</h1>
        <p className="subtitle">Admin access only</p>
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="admin@digsafe.co.uk"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="input"
          />
          {error && <p className="error">{error}</p>}
          <button type="submit" className="btn-primary">
            Send login link
          </button>
        </form>
      </div>
    </div>
  )
}
